/**
 * @file hooks/useBoolean
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import {useBoolean} from '@huse/boolean';

type BooleanHooks = [boolean, () => void, () => void, () => void];

export default (initialValue: boolean = false): BooleanHooks => {
    const [value, {on, off, toggle}] = useBoolean(initialValue);

    return [value, on, off, toggle];
};
